module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-note-wrapper markdown-body",
    class: [{
      'fullscreen': _vm.s_fullScreen,
      'shadow': _vm.boxShadow
    }],
    style: ({
      'box-shadow': _vm.boxShadow ? _vm.boxShadowStyle : ''
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbarsFlag),
      expression: "toolbarsFlag"
    }],
    staticClass: "v-note-op",
    style: ({
      'background': _vm.toolbarsBackground
    })
  }, [_c('v-md-toolbar-left', {
    ref: "toolbar_left",
    class: {
      'transition': _vm.transition
    },
    attrs: {
      "editable": _vm.editable,
      "transition": _vm.transition,
      "d_words": _vm.d_words,
      "toolbars": _vm.toolbars,
      "image_filter": _vm.imageFilter
    },
    on: {
      "toolbar_left_click": _vm.toolbar_left_click,
      "toolbar_left_addlink": _vm.toolbar_left_addlink,
      "imgAdd": _vm.$imgAdd,
      "imgDel": _vm.$imgDel,
      "imgTouch": _vm.$imgTouch
    }
  }, [_vm._t("left-toolbar-before", null, {
    "slot": "left-toolbar-before"
  }), _vm._v(" "), _vm._t("left-toolbar-after", null, {
    "slot": "left-toolbar-after"
  })], 2), _vm._v(" "), _c('v-md-toolbar-right', {
    ref: "toolbar_right",
    class: {
      'transition': _vm.transition
    },
    attrs: {
      "d_words": _vm.d_words,
      "toolbars": _vm.toolbars,
      "s_subfield": _vm.s_subfield,
      "s_preview_switch": _vm.s_preview_switch,
      "s_fullScreen": _vm.s_fullScreen,
      "s_html_code": _vm.s_html_code,
      "s_navigation": _vm.s_navigation
    },
    on: {
      "toolbar_right_click": _vm.toolbar_right_click
    }
  }, [_vm._t("right-toolbar-before", null, {
    "slot": "right-toolbar-before"
  }), _vm._v(" "), _vm._t("right-toolbar-after", null, {
    "slot": "right-toolbar-after"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "v-note-panel"
  }, [_c('div', {
    ref: "vNoteEdit",
    staticClass: "v-note-edit divarea-wrapper",
    class: {
      'scroll-style': _vm.s_scrollStyle, 'scroll-style-border-radius': _vm.s_scrollStyle && !_vm.s_preview_switch && !_vm.s_html_code, 'single-edit': !_vm.s_preview_switch && !_vm.s_html_code, 'single-show': (!_vm.s_subfield && _vm.s_preview_switch) || (!_vm.s_subfield && _vm.s_html_code), 'transition': _vm.transition
    },
    on: {
      "scroll": _vm.$v_edit_scroll,
      "click": _vm.textAreaFocus
    }
  }, [_c('div', {
    staticClass: "content-input-wrapper",
    style: ({
      'background-color': _vm.editorBackground
    })
  }, [_c('v-autoTextarea', {
    ref: "vNoteTextarea",
    staticClass: "content-input",
    style: ({
      'background-color': _vm.editorBackground
    }),
    attrs: {
      "placeholder": _vm.placeholder ? _vm.placeholder : _vm.d_words.start_editor,
      "fontSize": _vm.fontSize,
      "lineHeight": "1.5",
      "fullHeight": ""
    },
    model: {
      value: (_vm.d_value),
      callback: function($$v) {
        _vm.d_value = $$v
      },
      expression: "d_value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_preview_switch || _vm.s_html_code),
      expression: "s_preview_switch || s_html_code"
    }],
    staticClass: "v-note-show",
    class: {
      'single-show': (!_vm.s_subfield && _vm.s_preview_switch) || (!_vm.s_subfield && _vm.s_html_code)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.s_html_code),
      expression: "!s_html_code"
    }],
    ref: "vShowContent",
    staticClass: "v-show-content",
    class: {
      'scroll-style': _vm.s_scrollStyle, 'scroll-style-border-radius': _vm.s_scrollStyle
    },
    style: ({
      'background-color': _vm.previewBackground
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.d_render)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_html_code),
      expression: "s_html_code"
    }],
    staticClass: "v-show-content-html",
    class: {
      'scroll-style': _vm.s_scrollStyle, 'scroll-style-border-radius': _vm.s_scrollStyle
    },
    style: ({
      'background-color': _vm.previewBackground
    })
  }, [_vm._v("\n                " + _vm._s(_vm.d_render) + "\n            ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideTop"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_navigation),
      expression: "s_navigation"
    }],
    staticClass: "v-note-navigation-wrapper",
    class: {
      'transition': _vm.transition
    }
  }, [_c('div', {
    staticClass: "v-note-navigation-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.d_words.navigation_title)), _c('i', {
    staticClass: "fa fa-mavon-times v-note-navigation-close",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.toolbar_right_click('navigation')
      }
    }
  })]), _vm._v(" "), _c('div', {
    ref: "navigationContent",
    staticClass: "v-note-navigation-content",
    class: {
      'scroll-style': _vm.s_scrollStyle
    }
  })])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    ref: "help"
  }, [(_vm.s_help) ? _c('div', {
    staticClass: "v-note-help-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toolbar_right_click('help')
      }
    }
  }, [_c('div', {
    staticClass: "v-note-help-content markdown-body",
    class: {
      'shadow': _vm.boxShadow
    }
  }, [_c('i', {
    staticClass: "fa fa-mavon-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toolbar_right_click('help')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scroll-style v-note-help-show",
    domProps: {
      "innerHTML": _vm._s(_vm.d_help)
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.d_preview_imgsrc) ? _c('div', {
    staticClass: "v-note-img-wrapper",
    on: {
      "click": function($event) {
        _vm.d_preview_imgsrc = null
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.d_preview_imgsrc,
      "alt": "none"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "vReadModel",
    staticClass: "v-note-read-model scroll-style",
    class: {
      'show': _vm.s_readmodel
    }
  }, [_c('div', {
    ref: "vNoteReadContent",
    staticClass: "v-note-read-content",
    domProps: {
      "innerHTML": _vm._s(_vm.d_render)
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-329a5794", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-329a5794","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/mavon-editor.vue
// module id = 214
// module chunks = 0